export default __webpack_public_path__ + "static/media/pause.8bc214b2.svg";